import { connect } from 'react-redux'
import { IStore } from '../../../reducers'
import { getFromDate } from '../../../reducers/bookingCalendar/selectors/dates'
import { getIsLoading } from '../../../reducers/bookingCalendar/selectors/requestState'
import { getToggleSummary } from '../../../reducers/bookingCalendar/selectors/summary'
import PrintModal, { IPrintModalState } from './PrintModal'

const mapStateToProps = (state: IStore): IPrintModalState => ({
  initialDate: getFromDate(state),
  isCalendarLoading: getIsLoading(state),
  summaryToggled: getToggleSummary(state),
})

export default connect(mapStateToProps)(PrintModal)
